(ns ui.components.ck-editor.view
  (:require ["@ckeditor/ckeditor5-react" :refer [CKEditor]]
            ["@ckeditor/ckeditor5-build-decoupled-document" :as DecoupledEditor]
            [frontend.utils :as fu]
            [oops.core :as oops]
            [ui.device :as device]
            [ui.util :as uu]))

(def default-tool-bar-items ["Bold" "Italic" "Underline" "|" "BulletedList" "NumberedList" "|" "Alignment" "|" "Outdent" "Indent"])
(def toolbar-no-indent ["Bold" "Italic" "Underline" "|" "BulletedList" "NumberedList" "|" "Alignment"])

(defn editor
  [{:keys [_value _on-focus _on-blur _on-change _toolbar _toolbar-position]}]
  (let [local-state (atom {})]
    (fn [{:keys [value on-focus on-blur on-change toolbar toolbar-position]}]
      ;(js/console.log "EDITOR : " value " >> " toolbar)
      [:div
       {:class (uu/cm "flex flex-col flex-auto focus:outline-none focus:shadow-none"
                      "bg-input-light"
                      "[&_div.ck-content]:flex-auto [&_div.ck-content]:overflow-auto [&_div.ck-content]:max-h-[80vh]"
                      "[&_div.ck-content>ck]:flex-auto"
                      "[&_div.ck-toolbar]:mt-auto [&_div.ck-toolbar]:bg-base-regular"
                      "[&_ck-toolbar__separator]:hidden")
        :ref   (fn [dom]
                 (when (and dom (not= dom (:dom-node @local-state)))
                   (swap! local-state assoc :dom-node dom)))}
       [:> CKEditor
        {:editor   DecoupledEditor
         :data     (or value "")
         :config
         {:toolbar    (if (and (coll? toolbar) (seq toolbar))
                        toolbar
                        default-tool-bar-items)
          :licenseKey "GPL"}
         :onReady  (fn [editor]
                     (let [{:keys [dom-node initialized?]} @local-state]
                       (when (and editor
                                  dom-node
                                  (not initialized?)
                                  (not= :hidden toolbar-position))

                         (when (device/ios-browser?)
                           (js/console.log "IOS BROWSER")
                           ;; prevent autocorrect, capitalize spellcheck and inputmode -> breaks ipad safari and chrome
                           (oops/ocall (oops/oget editor "editing.view") "change"
                                       (fn [writer]
                                         (let [editable (oops/ocall (oops/oget editor "editing.view.document") "getRoot")]
                                           (oops/ocall writer "setAttribute" "autocorrect" "off" editable)
                                           (oops/ocall writer "setAttribute" "autocapitalize" "off" editable)
                                           (oops/ocall writer "setAttribute" "spellcheck" "false" editable)
                                           (oops/ocall writer "setAttribute" "inputmode" "text" editable))))

                           ;; if ipad safari / chrome bug happens, return cursor back to where it was
                           (let [model-document (oops/oget editor "model.document")
                                 model-selection (oops/oget model-document "selection")]
                             (oops/ocall model-selection "on" "change:range"
                                         (fn []
                                           (let [range (oops/ocall model-selection "getFirstRange")
                                                 position (oops/ocall model-selection "getFirstPosition")
                                                 current-offset (oops/oget position "offset")
                                                 parent (oops/oget position "parent")
                                                 root (oops/oget parent "root")
                                                 is-first-block? (and root parent
                                                                      (identical? parent
                                                                                  (oops/ocall root "getChild" 0)))
                                                 last-valid-offset (:last-valid-offset @local-state)
                                                 last-valid-selection (:last-valid-selection @local-state)]

                                             (cond
                                               (and (oops/oget range "isCollapsed")
                                                    (= current-offset 0)
                                                    is-first-block?
                                                    last-valid-offset
                                                    (> last-valid-offset 0))
                                               (do
                                                 (js/console.log "Reset cursor to: " last-valid-selection)
                                                 (when last-valid-selection
                                                   (oops/ocall (oops/oget editor "model") "change"
                                                               (fn [writer]
                                                                 (oops/ocall writer "setSelection" last-valid-selection)))))

                                               :else
                                               (do
                                                 (js/console.log "Update selection: " range current-offset)
                                                 (swap! local-state assoc
                                                        :last-valid-selection range
                                                        :last-valid-offset current-offset))))))))

                         (let [toolbar-container dom-node
                               append-js-fn (aget toolbar-container (if (= toolbar-position :bottom)
                                                                      "appendChild"
                                                                      "prepend"))
                               toolbar-element (-> editor .-ui .-view .-toolbar .-element)]
                           (when toolbar-element
                             (.call append-js-fn toolbar-container toolbar-element))
                           (swap! local-state assoc :initialized? true))
                         (oops/ocall editor "ui.focusTracker.on"
                                     "change:isFocused"
                                     (fn [_evt _evt-name value old-value]
                                       (cond (= value old-value)
                                             nil            ;; unexpected - no change
                                             value
                                             (when (fn? on-focus)
                                               (on-focus (oops/ocall editor "getData")))
                                             old-value
                                             (when (fn? on-blur)
                                               (on-blur (oops/ocall editor "getData")))))))))
         :onChange (fn [_evt editor]
                     (let [old-change-timeout (:change-timeout @local-state)]
                       (when old-change-timeout
                         (js/clearTimeout old-change-timeout))
                       (swap! local-state assoc
                              :change-timeout
                              (js/setTimeout
                                (fn [_]
                                  (when (fn? on-change)
                                    (try
                                      (on-change (oops/ocall editor "getData"))
                                      (catch js/Object o
                                        (js/console.error "Get data error : " o)))))
                                300))))
         :onFocus  (fn [_evt editor]
                     (when (fn? on-focus)
                       (on-focus (oops/ocall editor "getData"))))}]])))

(defn viewer
  [value]
  [:div
   [:> CKEditor
    {:editor  DecoupledEditor
     :onReady (fn [editor]
                (oops/ocall! editor "enableReadOnlyMode" "readonly"))
     :config  {:licenseKey "GPL"}
     :data    (fu/sanitize-html value)}]])











